import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTabsAtom } from '../../atoms/chat/useTabsAtom';
import { useSelectedTabAtom } from '../../atoms/chat/useSelectedTabAtom';
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';
import { useEnvNameAtom } from '../../atoms/chat/useEnvNameAtom';
import { useSelectedFlagAtom } from '../../atoms/chat/useSelectedFlagAtom';

import UserMenu from '../UserMenu';
import ChatComponent from './ChatComponent';
import EnvironmentsSelectBox from '../docs/EnvironmentsSelectBox';
import ChatQuestions from './ChatQuestions';
import useCookie from '../../hooks/useCookie';
import useAuth from "../../hooks/useAuth";

const countries = [
  { code: "sk", name: "SK", flag: "./sk-flag.png" },
  { code: "cz", name: "CZ", flag: "./cz-flag.png" }
];

const ChatWindow = () => {
  const { auth, userType } = useAuth();
  const navigate = useNavigate();
  const [t, ] = useTranslation('global');

  // Cookies 
  const [envCookie, setEnvCookie ] = useCookie("ENV"); // Environment Id
  const [envNameCookie, setEnvNameCookie] = useCookie("ENN"); // Environment Name 
  const [tabCookie, setTabCookie] = useCookie("TAB");
  const [flagCookie, setFlagCookie] = useCookie("FLA")

  const [tabs] = useTabsAtom();
  const tabsLength = tabs?.length; 
  const [selectedTab, setSelectedTab] = useSelectedTabAtom();
  const [, setChatEnvironmentId] = useChatEnvironmentAtom();
  const [selectedFlag, setSelectedFlag] = useSelectedFlagAtom();
  const [envName, setEnvName ] = useEnvNameAtom();
  
  const handleTabClick = debounce((intent) => {
    setSelectedTab(intent);
    setTabCookie("TAB", intent);
  }, 300);

  const handleBackToWizard = () => {
    // Clear environment-related cookies
    setEnvCookie(null);
    setFlagCookie(null);
    setEnvNameCookie(null);
    
    // Reset atoms
    setChatEnvironmentId(null);
    //setSelectedFlag(null);
    setEnvName(null);
    
    navigate('/Wizard');
  };

  useEffect(() => {

    if (userType === 'user' && envCookie) {
      setChatEnvironmentId(envCookie);
    }

    if (tabCookie && tabCookie !== selectedTab) {
      setSelectedTab(tabCookie);
    } else if (!tabCookie) {
      setTabCookie("TAB", selectedTab);
    }

    if (flagCookie) {
      setSelectedFlag(flagCookie);
    } else {
      console.log('no flag');
    }
    
    if (envNameCookie){
      setEnvName(envNameCookie);
    } else {
      console.log('no env name');
    }

    if (auth.uri) {
      if ([1,2,3].includes(auth.uri)) {
        setSelectedTab(tabs[0].intent);
      } else if (auth.uri === 4) {
        setSelectedTab(tabs[1].intent);
      }
    } 
  }, []); 

  useEffect(()=>{
    if (tabCookie){
      setSelectedTab(tabCookie);
    }
  },[tabCookie])

  useEffect(()=>{
    if (envNameCookie){
      setEnvName(envNameCookie);
    } else {
      console.log('no env name');
    }
  },[envNameCookie])

  const selectedCountry = userType === 'agent' 
    ? countries.find(country => country.code === flagCookie)
    : null;

  return (
    <>  
    <ChatQuestions />
    <div id="msgerWindow" className="chat-wrapper">
    <section className="msger">
      <div className='msger-logo-wrapper'>
        <div className='msger-logo'>
          <div className="premiumTitle">
          </div>
        </div>

        <header className="msger-header">

          <div className="msger-header-title">

            {/* Left Section (Only for 'agent' users) */}
            {userType === 'agent' && (
              <div className="left-section">
                <div onClick={handleBackToWizard} className="back-button">
                  <span className="material-symbols-outlined">arrow_back_ios</span>
                </div>
                <p className="selected-env-name">{envName}</p>
              </div>
            )}
            
            {/* Left Section (Only for 'user' users) */}
            {(selectedTab ===  'PromtEmbeddings' && userType === 'user') ?
              <EnvironmentsSelectBox /> 
            : null }

            <div className="right-section">
              {userType === 'agent' && (
                <img
                  src={selectedCountry.flag}
                  alt={selectedCountry.name}
                  style={{ width: 32, height: 32 }}
                />
              )}
              <UserMenu />
            </div>
            
          <div className='tab-menu-bar'>
              {tabsLength > 1 &&
                <div className="tabs-wrapper">
                  <div className="tabs">
                    {tabs.map((tab) => (
                      (tab.intent === 'PromtEmbeddings' && [1, 2, 4].includes(auth.uri)) ||
                      (tab.intent === 'PromptGpt') ||
                      (tab.intent === 'PromtData' && [1, 2, 3].includes(auth.uri)) ? (
                      <React.Fragment key={tab.radio}>
                        <input
                          type="radio"
                          id={`${tab.radio}`}
                          name="tabs"
                          checked={selectedTab === tab.intent}
                          onChange={() => handleTabClick(tab.intent)}
                        />
                        <label className="tab" htmlFor={`${tab.radio}`}>
                          <span className="material-symbols-outlined mobileOnly">{tab.icon}</span>
                          <span className='pcOnly'>{t(tab.label)}</span>
                        </label>
                      </React.Fragment>
                      ) : null
                    ))}
                    {[1,2].includes(auth.uri) ?<span className="glider"></span> : null }
                   
                  </div>
                </div>
                }
                {/* {(selectedTab ===  'PromtEmbeddings' && userType === 'user') ?
                  <EnvironmentsSelectBox /> 
                : null} */}
              </div> 
          </div>

          <div className="msger-header-options">
            <span>
              <i className="fas fa-cog"></i>
            </span>
          </div>          
        
        </header>
      </div>
      <ChatComponent/>
    </section>
    </div>
    </>
  );
};

export default ChatWindow;
